import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined'

import Button from '@mui/material/Button'

import useFormatMessage from '@hooks/useFormatMessage'
import ErrorLayout, { ErrorHero } from '@components/ErrorBase/ErrorBase.components'

export default function DOMMutation() {
  const formatMessage = useFormatMessage()

  return (
    <ErrorLayout
      hero={<ErrorHero icon={TranslateOutlinedIcon} />}
      title={formatMessage('error.translationUnavailable.title')}
      subtitle={formatMessage('error.translationUnavailable.description')}
      primary={
        <Button size="large" variant="contained" onClick={() => window.location.reload()}>
          {formatMessage('common.reload')}
        </Button>
      }
    />
  )
}
